module.exports = __webpack_public_path__ + "img/photo3.1c20fc65.png";